import { useNavigate, Navigate, useLocation } from "react-router-dom";
import "../styles/StudentAbsence.css";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import {
  fetchEducationCenters,
  fetchStudents,
} from "../services/data";
import { sendStudentAttendance } from "../services/pms";
import watomsBanner from "../assets/newLogo2.jpg";
import { useAuth } from "../context/AuthContext";
import LoadingScreen from "../components/LoadingScreen";
import DenyAccessPage from "../components/DenyAccessPage";

const currentDay = new Date().toISOString().split("T")[0];

function TraineeAbsence() {
  const { userInfo } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedDay, setSelectedDay] = useState(currentDay);
  const [vtcs, setVtcs] = useState([]);
  const [selectedVtc, setSelectedVtc] = useState("");
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [trainees, setTrainees] = useState([]);
  const [filteredTrainees, setFilteredTrainees] = useState([]);
  const [selectedTrainee, setSelectedTrainee] = useState("");
  const [selectedTrainees, setSelectedTrainees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      try {
        const vtcResponse = await fetchEducationCenters(2);
        const vtcIds = vtcResponse.map(v => v.id);
        setVtcs(vtcResponse);

        const traineesResponse = await fetchStudents();
        let filtered;
        let relatedCourses;
        if (userInfo.user_role === "Teacher") {
          const classesIds = userInfo.teacher_class.map(v => v.class.id);
          filtered = traineesResponse?.filter(s => s.school_id === userInfo.organization_id && s.class.status === "ongoing" && classesIds.includes(s.class_id));
          setSelectedTrainees(filtered)
        } else {
          filtered = userInfo.organization_id === 13
            ? traineesResponse?.filter(s => vtcIds.includes(s.school_id) && s.class.status === "ongoing")
            : traineesResponse?.filter(s => s.school_id === userInfo.organization_id && s.class.status === "ongoing");
          relatedCourses = [
            ...new Map(
              filtered.map(t => [t.class.id, t.class])
            ).values()
          ];
        }

        setFilteredCourses(relatedCourses);
        setTrainees(filtered);
        setFilteredTrainees(filtered);
      } catch (err) {
        console.error("API Error:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [userInfo]);

  useEffect(() => {
    const filterCourses = () => {
      const filtered = trainees?.filter(s => s.school_id === Number(selectedVtc) && s.class.status === "ongoing");
      const relatedCourses = [
        ...new Map(
          filtered.map(t => [t.class.id, t.class])
        ).values()
      ];
      setFilteredCourses(relatedCourses);
      setFilteredTrainees(filtered);
    }

    filterCourses();
  }, [selectedVtc])

  useEffect(() => {
    const filterTrainees = () => {
      let filtered
      if (userInfo?.user_role === 'Teacher') {
        filtered = trainees?.filter(s => s.class_id === Number(userInfo?.teacher_class?.class?.id) && s.class.status === "ongoing");
      } else {
        filtered = trainees?.filter(s => s.class_id === Number(selectedCourse) && s.class.status === "ongoing");
      }
      setFilteredTrainees(filtered);
    }

    filterTrainees();
  }, [selectedCourse])

  useEffect(() => {
    const filterTrainees = () => {
      if (
        selectedVtc === "" &&
        selectedCourse === "" &&
        selectedTrainee === ""
      ) {
        return;
      }

      const filtered = trainees.filter(item => {
        const matchOrg = selectedVtc === "" || selectedVtc === "All" || item.school_id === Number(selectedVtc);
        const matchCourse = selectedCourse === "" || selectedCourse === "All" || item.class_id === Number(selectedCourse);
        const matchId = selectedTrainee === "" || selectedTrainee === "All" || item.id === Number(selectedTrainee);

        return matchCourse && matchOrg && matchId;
      });

      setSelectedTrainees(filtered);
    }

    filterTrainees();
  }, [selectedVtc, selectedCourse, selectedTrainee, trainees]);

  const createTimestamp = () => {
    const today = new Date();

    // Extract current time components
    const hh = String(today.getHours()).padStart(2, "0");
    const mm = String(today.getMinutes()).padStart(2, "0");
    const ss = String(today.getSeconds()).padStart(2, "0");
    const ms = String(today.getMilliseconds()).padStart(2, "0");

    // selectedDay = "2025-09-19"
    return `${selectedDay} ${hh}:${mm}:${ss}.${ms}+00`;
  };

  const submitTraineesAttendance = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const attendanceData = [];

    selectedTrainees.forEach((trainee) => {
      const status = formData.get(`absenceStatus-${trainee.id}`);
      const reason = formData.get(`reason-${trainee.id}`);
      attendanceData.push({
        student_id: trainee.id,
        status,
        reason,
        createdAt: createTimestamp(),
        updatedAt: createTimestamp()
      });
    });

    try {
      await sendStudentAttendance(attendanceData);
      toast.success("تم تسجيل الحضور بنجاح");
    } catch (err) {
      toast.error("حدث خطا الرجاء المحاولة مرة اخري");
    }
  };

  if (loading) return <LoadingScreen />;
  if (error?.status === 403) return <Navigate to="/login" state={{ from: location }} replace />;
  if (error) return <p>Error: {error.message}</p>;
  if (userInfo.user_role !== "Operations Excellence Lead" && userInfo.user_role !== "Teacher" && userInfo.user_role !== "Trainer" && userInfo.user_role !== "ADMIN") return <DenyAccessPage homePage='/watoms/pms' />;
  if (userInfo?.code === 1452 || userInfo?.code === 1476) return <DenyAccessPage homePage='/watoms/dashboard' />;
  if (userInfo?.code === 1475) return <DenyAccessPage homePage='/watoms/news' />;
  if (userInfo?.code === 1310) return <DenyAccessPage homePage='/wisdom/dashboard' />;

  return (
    <div className="bg-formColor flex justify-center flex-wrap min-h-screen">
      <div className="flex justify-end w-full p-[5px] h-[6vh]">
        <button className="bg-wisdomOrange hover:bg-wisdomDarkOrange text-white text-center p-4 flex justify-center items-center rounded" onClick={() => navigate("/watoms/pms")}>رجوع &gt;</button>
      </div>
      <div className="w-full flex justify-center">
        <img
          className="md:w-[60%] w-full md:h-[30vh] h-fit"
          src={watomsBanner}
          alt="company logo"
        ></img>
      </div>
      <div className="w-full text-center flex justify-center items-center">
        <h1 className="text-2xl font-bold">غياب المتدرب</h1>
      </div>
      <div className="flex flex-col justify-center items-center w-full mb-2">
        {/* vtc selector */}
        {userInfo.organization_id === 13 ?
          <>
            <label>:اليوم</label>
            <input
              className="w-60 p-2"
              type="date"
              value={selectedDay}
              onChange={(e) => setSelectedDay(e.target.value)}
            />
          </>
          : null}
        {/* vtc selector */}
        {userInfo.organization_id === 13 ?
          <>
            <label>:المركز</label>
            <select
              id="vtc"
              name="vtc"
              onChange={(e) => setSelectedVtc(e.target.value)}
              value={selectedVtc}
              dir="rtl"
            >
              <option value="" disabled selected>
                الرجاء اختيار المركز
              </option>
              <option value="All">الكل</option>
              {vtcs.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                </option>
              ))}
            </select>
          </>
          : null}
        {/* course selector */}
        {userInfo.user_role !== "Teacher" &&
          <>
            <label>:الدورة التدريبية</label>
            <select
              id="course"
              name="course"
              onChange={(e) => setSelectedCourse(e.target.value)}
              value={selectedCourse || ""}
              dir="rtl"
            >
              <option value="" disabled>
                الرجاء اختيار دورة
              </option>
              <option value="All">الكل</option>
              {filteredCourses?.map((course) => (
                <option key={course.id} value={course.id}>
                  {course.name}
                </option>
              ))}
            </select>
          </>
        }
        {/* trainees selector */}
        <label>:متدرب</label>
        <select
          id="trainee"
          name="trainee"
          onChange={(e) => setSelectedTrainee(e.target.value)}
          value={selectedTrainee || ""}
          dir="rtl"
        >
          <option value="" disabled>
            الرجاء اختيار متدرب
          </option>
          <option value="All">الكل</option>
          {filteredTrainees.map((student) => (
            <option key={student.id} value={student.id}>
              {`${student.first_name} ${student.middle_name} ${student.last_name}`}
            </option>
          ))}
        </select>
      </div>
      {selectedTrainees.length > 0 ? (
        <form className="teacherSessions" onSubmit={submitTraineesAttendance}>
          <div className="students">
            <div className="studentTitle">:الاسم</div>
            <div className="studentTitle">:الحالة</div>
            <div className="studentTitle">السبب (اختياري)</div>
          </div>
          {selectedTrainees.map((student) => (
            <div className="students" key={student.id}>
              <div className="md:min-w-[200px] text-center flex justify-center items-center flex-col w-[30%]">
                <div className="">
                  {student.first_name} {student.middle_name} {student.last_name}
                </div>
              </div>
              <div className="flex justify-center items-center flex-col w-[30%]">
                <select
                  id={`absenceStatus-${student.id}`}
                  name={`absenceStatus-${student.id}`}
                  className="w-full"
                >
                  <option value="attend">حاضر</option>
                  <option value="absent">غائب</option>
                  <option value="late">متاخر</option>
                  <option value="left with parent">رحل</option>
                </select>
              </div>
              <div className="flex justify-center items-center flex-col w-[30%]">
                <input
                  id={`reasonInput ${student.id}`}
                  name={`reason-${student.id}`}
                  type="text"
                  className="px-3 py-2 border border-gray-300 rounded-lg text-sm outline-none transition-colors duration-200 w-full"
                />
              </div>
            </div>
          ))}
          <button className="TLBtn bg-wisdomOrange hover:bg-wisdomDarkOrange text-white font-bold px-2 py-1 rounded">ارسال</button>
        </form>
      ) : (
        <div className="noTeacher">لا يوجد بيانات حاليا</div>
      )}
    </div>
  );
}

export default TraineeAbsence;